import React from 'react';
import { Link } from 'react-router-dom';
import { themeStyleVars } from './theme';
import Hero from './Hero';
import LearningObjectives from './LearningObjectives';
import Sessions from './Sessions';
import Instructors from './Instructors';
import Bonuses from './Bonuses';
import Testimonials from './Testimonials';
import Faqs from './Faqs';
import { resolveCtaText } from '../../utils/landingCta';
import styles from './LandingPage.module.css';

const PROSPERITY_LOGO =
  'https://media.publit.io/file/ProsperityWebApp/Prosperity-Elephant-WIDE-BLUEPNG.png';

/**
 * Native React landing page — single rendering path for public page and editor preview.
 */
export default function LandingPage({
  event,
  sessions = [],
  learningObjectives = [],
  faqs = [],
  testimonials = [],
  bonuses = [],
  instructors = [],
  theme = 'prosperity',
  density = 'full',
  heroStyle = 'form',
  refSlug = null,
  className = '',
}) {
  if (!event?.id) return null;

  const language = event?.language ?? 'en';
  const showFullSections = density !== 'compact';
  const ctaText = resolveCtaText(event);
  const registerPath = refSlug
    ? `/register/${event.id}?ref=${encodeURIComponent(refSlug)}`
    : `/register/${event.id}`;

  return (
    <div
      className={`${styles.root} ${className}`.trim()}
      style={themeStyleVars(theme)}
      data-lp-theme={theme}
      data-lp-density={density}
      data-lp-hero-style={heroStyle}
    >
      <nav className={styles.nav}>
        <div className={styles.container}>
          <div className={styles.navLogo}>
            <img src={PROSPERITY_LOGO} alt="Prosperity Leaders" />
          </div>
          <span className={styles.navTitle}>{event?.title}</span>
          <Link to={registerPath} className={styles.btnSm}>
            {ctaText} →
          </Link>
        </div>
      </nav>

      <Hero
        event={event}
        sessions={sessions}
        eventId={event.id}
        refSlug={refSlug}
        heroStyle={heroStyle}
      />

      <LearningObjectives items={learningObjectives} language={language} />

      {showFullSections && (
        <Sessions sessions={sessions} event={event} language={language} />
      )}

      <Instructors instructors={instructors} language={language} />

      {showFullSections && (
        <Bonuses bonuses={bonuses} language={language} />
      )}

      <Testimonials testimonials={testimonials} language={language} />

      <Faqs faqs={faqs} language={language} />

      <footer className={styles.footer}>
        <div className={styles.container}>
          <img src={PROSPERITY_LOGO} alt="Prosperity Leaders" className={styles.footerLogo} />
          <p className={styles.footerText}>
            © {new Date().getFullYear()} Prosperity Leaders. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
